import { PlatformPrivateServices } from '../../PlatformPrivateServices';

export class BlocksMigrationNamespaceContext {
  constructor(
    private readonly ps: PlatformPrivateServices,
    private readonly manifestContextId: string,
    private readonly childPath: number[] = [],
  ) {}

  getQuery() {
    return this.ps.manifestServicesHost.getContextualManifestAPI(
      this.manifestContextId,
      this.childPath,
    ).query;
  }
}
